import { useState, useCallback } from 'react';
import { message } from 'antd';
import { p131kApi, QueryParams, ReportRow } from '../../../services/p131kApi';

export function useP131KQuery() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await p131kApi.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setNoData(false);
      } else {
        setData([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, queried, noData, runQuery, reset };
}
